import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomPopup from "../../../custom-components/CustomPopup";
import { useAppDispatch } from "../../../custom-hooks/useAppDispatch";
import { UserServiceImpl } from "../../../services/UserServiceImpl";
import LogoutIconSVG from "../../resources/svg/LogoutIconSVG";
import { useNavigate } from "react-router-dom";

const Logout: FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const logoutHandler = async () => {
        const result = await dispatch(UserServiceImpl.logoutThunk());
        if (result.meta.requestStatus === "fulfilled") {
            navigate("/login");
        }
    };

    return (
        <CustomPopup
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            wrapClassName="dmin2:min-w-[628px] di6:min-w-[428px] ti6:min-w-[428px] ti7:min-w-[340px] tmax4:min-w-[340px]"
            confirmTitle={t("common.yes")}
            confirmHandler={logoutHandler}
            confirmButtonClassName="bg-transparent hover:bg-transparent w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mr-8 dmax2:mr-6 mt-8 dmax2:mt-6"
            cancelTitle={t("common.no")}
            cancelButtonClassName="w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mt-8 dmax2:mt-6"
            buttonElement={
                <div
                    onClick={() => setIsVisible(true)}
                    className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] group"
                >
                    <LogoutIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                    <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                        {t("common.logout")}
                    </span>
                </div>
            }
        >
            <p className="H20 dmax2:H16 text-textWhite text-center mt-[10px] dmin2:max-w-[420px] di6:max-w-[320px] ti6:max-w-[320px] ti7:max-w-[280px] tmax4:max-w-[280px]">
                {t("login.logoutConfirmation")}
            </p>
        </CustomPopup>
    );
};

export default Logout;
